import * as React from 'react'

const COMPACT_BREAKPOINT = 1600

export function useIsCompactViewport() {
  const [isCompact, setIsCompact] = React.useState<boolean | undefined>(
    undefined
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${COMPACT_BREAKPOINT}px)`)
    const onChange = () => {
      setIsCompact(mql.matches)
    }
    mql.addEventListener('change', onChange)
    setIsCompact(mql.matches)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isCompact
}
